import { Block, Check, ErrorOutline } from '../Icons'
import { Chip } from './mui'

type Severity = 'error' | 'info' | 'none' | 'success' | 'warning'
interface AvailabilityChipProps {
  availability: string
  severity?: Severity
}

export function AvailabilityChip({ availability, severity = 'none' }: AvailabilityChipProps) {
  let bgColor = ''
  let color
  let icon = undefined
  switch (severity) {
    case 'error':
      bgColor = 'error'
      icon = <Block />
      color = 'error' as const
      break
    case 'info':
      bgColor = 'info.light'
      icon = <Check />
      color = 'info' as const
      break
    case 'success':
      bgColor = 'success.light'
      icon = <Check />
      color = 'success' as const
      break
    case 'warning':
      bgColor = 'warning.light'
      icon = <ErrorOutline />
      color = 'warning' as const
      break
  }

  return (
    <Chip
      sx={{
        textTransform: 'capitalize',
        fontSize: 12,
        backgroundColor: bgColor,
      }}
      icon={icon}
      size='small'
      clickable={false}
      label={availability}
      color={color}
    />
  )
}

export function getAvailabilityPropsFromApi(availability?: TrinityAPI.AvailabilityType) {
  if (!availability) {
    return { availability: 'not available', severity: 'error' as Severity }
  }
  if (availability.inStock && availability.readiness == 'at factory') {
    return { availability: availability.readiness, severity: 'success' as Severity }
  }
  if (availability.inStock) {
    return { availability: availability.readiness, severity: 'info' as Severity }
  }
  if (!availability.inStock) {
    return { availability: 'temp. out', severity: 'warning' as Severity }
  }
  return { availability: 'unknown', severity: 'error' as Severity }
}
